import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BuenoWebApiResult } from 'src/app/shared/models/bueno-api-response';
import { OAuthService } from 'angular-oauth2-oidc';
import { BaseApiService } from './base-api.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class KycService {
  private httpClient = inject(HttpClient);
  private oAuth = inject(OAuthService);
  private baseApiUrl = inject<string>('BASE_API_URL' as any);
  private baseApiService = inject(BaseApiService);
  private userService = inject(UserService);

  initializeKyc(kycModel: any): Observable<any> {
    return this.httpClient.post<BuenoWebApiResult>(`${this.baseApiUrl}/kyc/RequestUrlKyc`, kycModel).pipe(
      map((response: BuenoWebApiResult) => response),
      catchError(error => throwError(() => this.baseApiService.handleError(error)))
    );
  }

  initializeKycSms(kycModel: any): Observable<any> {
    return this.httpClient.post<BuenoWebApiResult>(`${this.baseApiUrl}/kyc/RequestUrlKyc`, kycModel).pipe(
      map((response: BuenoWebApiResult) => response),
      catchError(error => throwError(() => this.baseApiService.handleError(error)))
    );
  }

  setKycPending(): Observable<any> {
    return this.httpClient.post<BuenoWebApiResult>(`${this.baseApiUrl}/kyc/MarkAsPending`, null).pipe(
      map((response: BuenoWebApiResult) => response),
      catchError(error => throwError(() => this.baseApiService.handleError(error)))
    );
  }

  simulateKycVerification(): Observable<any> {
    return this.httpClient.post<BuenoWebApiResult>(`${this.baseApiUrl}/kyc/SimulateKycVerification`, null).pipe(
      map((response: BuenoWebApiResult) => response),
      catchError(error => throwError(() => this.baseApiService.handleError(error)))
    );
  }
}
